module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_unteriberg-0e10342b6ba48a254ccb50b98f2591cc.png";